const reviewsCards = document.querySelectorAll('.review-preview');

if (reviewsCards) {
  reviewsCards.forEach((reviewsCard) => {
    const reviewsCaption = reviewsCard.querySelector('.review-preview__caption');
    const reviewsShowMore = reviewsCard.querySelector('.review-preview__show-more');

    if (reviewsShowMore) {
      const showBtn = () => {
        reviewsShowMore.classList.remove('is-show');

        if (reviewsCaption.scrollHeight > reviewsCaption.offsetHeight) {
          reviewsShowMore.classList.add('is-show');
        }
      };

      showBtn();
      window.addEventListener('resize', () => {
        showBtn();
      });
    }
  });
}
